// Modal de confirmación al avanzar de estado.
// Suena un "ding" al abrirse y tiene un botón OK que ejecuta onOk
// (típicamente: volver a la lista de pedidos).

import React, { useEffect } from "react";
import { createPortal } from "react-dom";

// Beep de éxito generado con Web Audio (no depende de ningún archivo).
// Como el modal se abre tras un click del usuario, el audio está habilitado.
function playDing() {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.connect(g); g.connect(ctx.destination);
    o.type = "sine";
    o.frequency.setValueAtTime(880, ctx.currentTime);          // La5
    o.frequency.setValueAtTime(1318.5, ctx.currentTime + 0.1); // Mi6
    g.gain.setValueAtTime(0.18, ctx.currentTime);
    g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.32);
    o.start();
    o.stop(ctx.currentTime + 0.32);
    setTimeout(() => { try { ctx.close(); } catch (_) {} }, 600);
  } catch (_) { /* sin sonido si el navegador no lo permite */ }
}

export default function EstadoConfirmModal({ titulo, mensaje, onOk }) {
  useEffect(() => { playDing(); }, []);

  return createPortal(
    <div
      style={{
        position: "fixed", inset: 0, zIndex: 10000,
        background: "rgba(0,0,0,0.55)",
        display: "flex", alignItems: "center", justifyContent: "center",
        padding: "20px",
      }}
      onClick={onOk}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: "#fff", borderRadius: "18px",
          width: "100%", maxWidth: "380px",
          padding: "28px 24px 22px", textAlign: "center",
          boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
        }}
      >
        <div style={{
          width: "64px", height: "64px", borderRadius: "50%",
          background: "#dcfce7", display: "flex", alignItems: "center",
          justifyContent: "center", margin: "0 auto 14px", fontSize: "32px",
        }}>
          ✅
        </div>
        <h3 style={{ margin: "0 0 6px", fontSize: "1.15rem", fontWeight: 800, color: "#0f172a" }}>
          {titulo}
        </h3>
        {mensaje && (
          <p style={{ margin: "0 0 20px", fontSize: "0.92rem", color: "#475569", lineHeight: 1.5 }}>
            {mensaje}
          </p>
        )}
        <button
          type="button"
          onClick={onOk}
          autoFocus
          style={{
            width: "100%", padding: "14px", borderRadius: "12px", border: "none",
            background: "#16a34a", color: "#fff", fontWeight: 800, fontSize: "1rem",
            cursor: "pointer",
          }}
        >
          OK
        </button>
      </div>
    </div>,
    document.body
  );
}
